module.exports = {"TXTMOB_Exclusive":{"id":"TXTMOB_Exclusive","defaultMessage":"Αποκλειστικό","flags":["TRACK"],"track":"Exclusive"}}